<template>
  <el-dialog
    :visible="visible"
    width="1200px"
    append-to-body
    :close-on-click-modal="false"
    class="page-dialog center-dialog-no-footer"
    @update:visible="val => emitUpdateVisible(val)"
  >
    <template #title>
      <MemberUidHeader :username="targetInfo.username" :uid="uid" :vip-level="targetInfo.vip_level">
        <span class="dialog-subtitle">投注记录</span>
      </MemberUidHeader>
    </template>
    <ManageTransactionInfoTabV2 :target-info="targetInfo" :is-active="visible" :reset-key="resetKey" />
  </el-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import ManageTransactionInfoTabV2 from './tabs/ManageTransactionInfoTabV2.vue'
import MemberUidHeader from './MemberUidHeader.vue'

export default {
  name: 'BetHistoryDialogV2',
  components: { ManageTransactionInfoTabV2, MemberUidHeader },
  props: {
    visible: { type: Boolean, default: false },
    uid: { type: [Number, String], default: null },
    targetInfo: { type: Object, default: () => ({}) },
  },
  setup(props, { emit }) {
    const resetKey = ref(0)
    const emitUpdateVisible = val => emit('update:visible', val)

    watch(
      () => props.visible,
      v => {
        if (v) resetKey.value += 1
      }
    )

    return { resetKey, emitUpdateVisible }
  },
}
</script>

<style lang="scss" scoped>
.dialog-subtitle {
  color: #606266;
  font-weight: 500;
}
</style>
